<template>
  <section class="pcd-pool" :aria-label="t(&quot;我的 PCD 分紅池佔比&quot;)">
    <div class="pcd-pool-ring">
      <svg viewBox="0 0 112 112" aria-hidden="true">
        <circle class="pcd-pool-track" cx="56" cy="56" r="48" />
        <circle v-if="ready" class="pcd-pool-own" cx="56" cy="56" r="48" pathLength="100" :stroke-dasharray="`${pool.share} 100`" transform="rotate(-90 56 56)" data-testid="pool-arc" />
      </svg>
      <div><strong data-testid="pool-share">{{ t(ready ? formatAmount(pool.share) + '%' : '—') }}</strong><span>{{ t("我的佔比") }}</span></div>
    </div>
    <div class="pcd-pool-copy">
      <h2>{{ t("PCD 分紅池") }}</h2>
      <template v-if="ready">
        <p><i class="pcd-pool-dot" aria-hidden="true" />{{ t("我的質押") }} <strong>{{ t(formatDisplay(staked)) }}</strong> PCD</p>
        <p><i class="pcd-pool-dot pcd-pool-dot-other" aria-hidden="true" />{{ t("其他質押") }} <strong>{{ t(formatAmount(100 - pool.share)) }}%</strong></p>
        <p class="pcd-muted">{{ t("全池質押") }} {{ t(formatDisplay(total)) }} PCD</p>
      </template>
      <p v-else class="pcd-muted" role="status">{{ t(!loaded ? '連接錢包並讀取分紅池資料' : status !== 'ready' ? '分紅池尚未更新，請重新讀取' : pool.state === 'empty' ? '全池暫無質押' : '分紅池資料異常，請重新讀取') }}</p>
    </div>
  </section>
</template>
<script setup>
import { t } from '@/i18n';
import { computed } from 'vue';
import { formatAmount } from './format';
import { dividendPool, formatDisplay } from './displayFormat';
const props = defineProps({ staked: [Number, String], total: [Number, String], loaded: Boolean, status: String });
const pool = computed(() => dividendPool(props.staked, props.total));
const ready = computed(() => props.loaded && props.status === 'ready' && pool.value.state === 'ready');
</script>
